import React, { useState, useEffect, useContext } from "react";
import AdminCard from "../../../components/AdminDashboard/AdminCard/AdminCard";
import "./AdminHome.css";
import { Button, CircularProgress } from "@mui/material";
import { ThemeProvider } from "@emotion/react";
import Input from "@mui/joy/Input";
import SearchIcon from "@mui/icons-material/Search";
import theme from "../../../themes/theme";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import AdminLayout from "../../../components/AdminDashboard/AdminLayout/AdminLayout";
import { useNavigate } from "react-router";
import FormControl from "@mui/material/FormControl";
import BASE_URL from "../../../config/api";
import axios from "axios";
import { AppContext } from "../../../context/AppContext";

export default function AdminHome() {
  const [courses, setCourses] = useState([]);
  const [filteredCourses, setFilteredCourses] = useState([]);
  const [selectedOption, setSelectedOption] = useState(1);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();
  const { token } = useContext(AppContext);

  const handleClick = () => {
    navigate("/create-course");
  };

  const handleSelectChange = (event) => {
    setSelectedOption(event.target.value);
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/courses`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setCourses(response.data);
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };
    if (token) fetchCourses();
  }, [token]);

  useEffect(() => {
    const filtered = courses.filter((course) => course.title.toLowerCase().includes(searchQuery.toLowerCase()) || course.instructor.toLowerCase().includes(searchQuery.toLowerCase()));

    const sorted = [...filtered];
    if (selectedOption === 1) {
      sorted.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
    } else if (selectedOption === 2) {
      sorted.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
    }

    setFilteredCourses(sorted);
  }, [courses, searchQuery, selectedOption]);

  return (
    <>
      <AdminLayout>
        {loading ? (
          <CircularProgress />
        ) : courses && courses.length > 0 ? (
          <div className="courses">
            <p className="title">Courses</p>
            <div className="course-box">
              <div className="options">
                <div className="search">
                  <Input
                    variant="soft"
                    placeholder="Search by name or lecturer"
                    sx={{
                      maxWidth: "150%",
                      minWidth: "450px",
                    }}
                    value={searchQuery}
                    onChange={handleSearchChange}
                  ></Input>
                  <div className="btn-search-icon">
                    <ThemeProvider theme={theme}>
                      <Button variant="contained" sx={{ padding: "0px -2px" }}>
                        <SearchIcon />
                      </Button>
                    </ThemeProvider>
                  </div>
                </div>
                <FormControl
                  variant="filled"
                  sx={{
                    border: "0",
                  }}
                >
                  <Select
                    value={selectedOption}
                    onChange={handleSelectChange}
                    sx={{
                      fontWeight: "500",
                      color: "#6D7791",
                      backgroundColor: " #F0F4F8",
                      borderBottom: "none",
                      fontFamily: "Inter",
                      width: "130px",
                      height: "50px",
                      borderRadius: "4px",
                    }}
                  >
                    <MenuItem sx={{ fontWeight: "600" }} value={1}>
                      Newest
                    </MenuItem>
                    <MenuItem sx={{ fontWeight: "600" }} value={2}>
                      Earliest
                    </MenuItem>
                  </Select>
                </FormControl>
              </div>
              <div className="create-new-btn">
                <ThemeProvider theme={theme}>
                  <Button variant="contained" onClick={handleClick} sx={{ padding: "0px -2px" }}>
                    Create New Course
                  </Button>
                </ThemeProvider>
              </div>
            </div>
            {filteredCourses.map((course) => (
              <AdminCard key={course._id} course={course} id={course._id} />
            ))}
          </div>
        ) : (
          <>
            <p className="no-courses">No courses available</p>
            <ThemeProvider theme={theme}>
              <Button variant="contained" onClick={handleClick} sx={{ padding: "0px -2px", width: "200px" }}>
                Create new course
              </Button>
            </ThemeProvider>
          </>
        )}
      </AdminLayout>
    </>
  );
}
